import styled from "@emotion/styled";
import { colors } from "../utils/style";

export const Line = styled.hr`
  border: 0;
  margin: 0;
  border-bottom: 1px solid ${colors.border.secondary};
  width: 100%;
`;
